import { render, staticRenderFns } from "./InvoicedExpenseDonut.vue?vue&type=template&id=678e07e4"
import script from "./InvoicedExpenseDonut.vue?vue&type=script&lang=js"
export * from "./InvoicedExpenseDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports